import { A11y, Navigation, Pagination } from 'swiper/modules'
import { SwiperSlide } from 'swiper/react'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { Button, WContainer } from '@components/atoms'
import { SimpleCard } from '@components/molecules'
import { GenericSection, GenericSlider } from '@components/organisms'
import styles from './CardSwiper.module.sass'

interface Props {
  id: string
  refId?: string
  item: MenuItemType
  theme?: GenericSectionThemeType
  size?: 'lg' | 'md'
  handleClickTracking?: (item: any, index: number) => void
  className?: string
}

const CardSwiper = (props: Props) => {
  const {
    id = undefined,
    refId = undefined,
    item = undefined,
    theme = 'white',
    size = 'md',
    handleClickTracking = undefined,
    className = '',
  } = props

  return item?.children?.length > 0 ? (
    <GenericSection
      refId={refId}
      item={item}
      theme={theme}
      className={`${styles.root} ${styles[`root--${size}`]} ${className}`}
    >
      <div className={`${styles.slider}`}>
        <GenericSlider
          id={id}
          navigationPos="pagination"
          conf={{
            slidesPerView: 1.1,
            spaceBetween: 10,
            modules: [A11y, Navigation, Pagination],
            navigation: true,
            pagination: { clickable: true },
            breakpoints: {
              768: {
                slidesPerView: size === 'lg' ? 2.1 : 2.3,
              },
              1024: {
                slidesPerView: size === 'lg' ? 2 : 3,
                spaceBetween: 20,
              },
            },
          }}
        >
          {item.children.map((i, index) => (
            <SwiperSlide key={index}>
              <SimpleCard
                item={i}
                size={size}
                onClick={() => {
                  handleClickTracking ? handleClickTracking(i, index) : null
                }}
              />
            </SwiperSlide>
          ))}
        </GenericSlider>
      </div>
    </GenericSection>
  ) : (
    <></>
  )
}

export default CardSwiper
